module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-rc.8-225.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1-rc.8.md
// module id = 669
// module chunks = 315